import {createActions} from 'reduxsauce';

export const actions = createActions(
  {
    setPlatformParams: ['isNative', 'isIos', 'isAndroid', 'isMobile'],
  },
  {prefix: 'platform'},
);
